import { Outlet, createFileRoute } from '@tanstack/react-router';
import { ensureMeContext } from '@vizit/api';
import { PlainChatLauncher } from '../init/plain';
import { ErrorPageTemplate } from '../templates';

// Prefetches GET /v1/me once so beforeLoad guards never race the boot query.
export const Route = createFileRoute('/_authenticated')({
  staticData: {
    pageName: '',
    isPathless: true,
  },
  beforeLoad: async ({ context }) => {
    if (!context.auth?.isAuthenticated) {
      return;
    }

    await ensureMeContext(context.queryClient, context.auth?.userId);
  },
  component: AuthenticatedLayout,
  errorComponent: AuthenticatedError,
});

// The chat launcher lives here rather than in a page template: each route mounts its own template, and remounting the
// launcher on every navigation would close an open conversation.
function AuthenticatedLayout() {
  return (
    <>
      <Outlet />
      <PlainChatLauncher />
    </>
  );
}

function AuthenticatedError() {
  return (
    <ErrorPageTemplate
      errorMessage="We couldn't load your account. Please try again."
      onGoHome={() => {
        window.location.href = '/';
      }}
      onTryAgain={() => {
        window.location.reload();
      }}
    />
  );
}
